import { useState, useEffect, useMemo } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Alert, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ApiPromoCategory from "../../../core/api/api.promocategory";
import ApiPromocategorycommision from "../../../core/api/api.promocategorycommision";
import ApiPromocategoryagent from "../../../core/api/api.promocategoryAgent";
import ApiAgent from "../../../core/api/api.agent";
import SwalMessage from "../_Components/SwalMessage";
import { useLocation } from "react-router-dom";
import SelectComponent from "../_Components/ReactSelectComponent";

export const NewPromoCategoryAgentModal = (props) => {
  let location = useLocation();

  const {
    handleSubmit,
    control,
    formState: { isSubmitting, submitCount },
    setValue,
  } = useForm({
    defaultValues: {},
  });

  const [listData, setListData] = useState([]);
  const [allAgentList, setAllAgentList] = useState([]);
  const [allCommisionList, setAllCommisionList] = useState([]);
  const locationS = useMemo(() => location?.state?.AgentId, [location?.state?.AgentId]);
  const [textMessage, settextMessage] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const resultPromoCategory = await ApiPromoCategory.getAll({ pageSize: 200, pageNumber: 1 });
        if (resultPromoCategory?.data) {
          setListData(resultPromoCategory.data);
        }

        const restAgent = await ApiAgent.getAllAgent({ pageSize: 200, pageNumber: 1 });
        restAgent?.data && setAllAgentList(restAgent.data.filter(agent => agent.isActive == true));
        if (location?.state?.AgentId) {
          ApiPromocategoryagent.get(location?.state?.AgentId).then((rest) => {

            setValue("PromoCategoryId", resultPromoCategory?.data?.map((item) => ({
              value: item.id,
              label: item.name,
            })).find(item => item.value == rest.promoCategoryId));
            setValue("PromoCategoryCommisionId", allCommisionList?.map((item) => ({
              value: item.id,
              label: item.name,
            })).find(item => item.value == rest.promoCategoryCommisionId));
            setValue("agentName", {
              value: rest.agent.id,
              label: rest.agent.companyName,
            });
          });
        }
      } catch (error) {
      } finally {
      }
    })();

    return () => { };
  }, []);
  const onSubmit = async (data) => {
    settextMessage([]);

    try {

      if (_.isUndefined(data.PromoCategoryCommisionId)) {
        SwalMessage({ title: "گروه کمیسیون انتخاب نشده است", iSsuccess: false });
      }
      if (_.isUndefined(data.PromoCategoryId)) {

        SwalMessage({ title: "گروه تخفیف انتخاب نشده است", iSsuccess: false });
      }
      if (_.isUndefined(data.agentName)) {

        SwalMessage({ title: "نماینده انتخاب نشده است", iSsuccess: false });
      } else {

        data.agentIdList = [];
        let tt = data?.agentName.map((item) => data.agentIdList.push(item.value));
        data.PromoCategoryId = data.PromoCategoryId.value
        data.PromoCategoryCommisionId = data.PromoCategoryCommisionId.value
        let response = await ApiPromocategoryagent.addOrEditPromoCategoryAgent(data);
        let Msg = JSON.parse(response?.message);
        settextMessage(Msg);
      }
    } catch (error) { }
  };
  // const selectStyles = {
  //   menu: (base) => ({
  //     ...base,
  //     zIndex: 10000,
  //   }),
  // };
  function handleChangeMulti(event) {
    setValue("agentName", event);
  }

  const getCommisionList = async (promoCAtegoryId) => {
    const restPCCommision = await ApiPromocategorycommision.getCommisionByPromoCategoryId(promoCAtegoryId);
    restPCCommision?.data && setAllCommisionList(restPCCommision.data);
  };
  let handleClose = (e) => {
    if (submitCount)
      document.getElementById("submitButton").click()
    props.setShowModalPromoCategoryAgent(false)
  };
  return (
    <div>
      <Modal centered size="md" show={true} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>تخصیص گروه تخفیف به نمایندگان</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col xs="12">
              <Controller
                name="agentName"
                control={control}
                render={({ field }) => (
                  <SelectComponent
                    closeMenuOnSelect={false}
                    options={allAgentList?.map((item) => ({
                      value: item.id,
                      label: item.companyName,
                    }))}
                    placeholder="انتخاب نماینده"
                    className="mt-2"
                    field={field}
                    onChange={handleChangeMulti}
                    isMulti
                    isDisabled={locationS && true}
                  />
                )}
              />
            </Col>
            <Col xs="12" className="mt-3">
              <Controller
                name="PromoCategoryId"
                control={control}
                rules={{}}
                render={({ field: { value, onChange } }) => (
                  <SelectComponent
                    className="mt-2"
                    placeholder="انتخاب گروه تخفیف"
                    options={listData?.filter(item => item.isActive).map((item) => ({
                      value: item.id,
                      label: item.name,
                    }))}
                    disabled={locationS && true}
                    value={value}
                    onChange={(e) => {
                      getCommisionList(e?.value)
                      onChange(e)
                    }}
                  />
                )}
              />
            </Col>
            <Col xs="12">
              <Controller
                name="PromoCategoryCommisionId"
                control={control}
                rules={{}}
                render={({ field }) => (
                  <SelectComponent
                    className="mt-2"
                    placeholder="انتخاب کمیسیون گروه تخفیف"
                    options={allCommisionList?.filter(item => item.isActive).map((item) => ({
                      value: item.id,
                      label: item.name,
                    }))}
                    field={field}
                  />
                )}
              />
            </Col>
            <Col xs="12">
              {textMessage != [] &&
                textMessage.map((item, index) => (
                  <Alert key={index} variant={item.succeeded == false ? "danger" : "success"}>
                    {item.Message}
                  </Alert>
                ))}
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
